import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import * as serviceActions from '../service/actions';

const styles = theme => ({
    dialogTitle: {
        position: 'relative',
        paddingRight: theme.spacing(6),
        paddingBottom: theme.spacing(1),
        fontFamily: 'Sofia-bold'
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    dialogContent: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        fontFamily: 'Sofia'
    },
    textField: {
        width: '100%',
        fontFamily: 'Sofia',
        '& .MuiOutlinedInput-root': {
            fontFamily: 'Sofia',
            '&.Mui-focused fieldset': {
                borderColor: '#7F2062'
            }
        },
        '& .MuiInputLabel-root': {
            fontFamily: 'Sofia'
        }
    },
    helperText: {
        marginTop: theme.spacing(1),
        color: '#666',
        fontSize: '0.9rem',
        fontFamily: 'Sofia'
    },
    dialogActions: {
        padding: theme.spacing(2),
        justifyContent: 'center'
    },
    button: {
        fontFamily: 'Sofia',
        textTransform: 'none',
        borderRadius: 100,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    allocateButton: {
        backgroundColor: '#7F2062',
        color: '#fff',
        fontFamily: 'Sofia',
        fontWeight: 700,
        textTransform: 'none',
        borderRadius: 100,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        '&:hover': {
            backgroundColor: '#6A1B52'
        },
        '&:disabled': {
            backgroundColor: '#ccc'
        }
    }
});

class PurchaseNumberDialog extends Component {
    state = {
        areaCode: '',
        allocating: false,
        error: null
    };

    handleClose = () => {
        if (!this.state.allocating) {
            this.setState({
                areaCode: '',
                allocating: false,
                error: null
            });
            this.props.onClose();
        }
    };

    handleAreaCodeChange = (event) => {
        const value = event.target.value
            .replace(/[^0-9]/g, '')  
            .substring(0, 3);         
        this.setState({ areaCode: value, error: null });
    };

    handleAllocate = () => {
        const { accountId, allocatePhoneNumber } = this.props;
        const { areaCode } = this.state;

        // Validation
        if (!areaCode || areaCode.length !== 3) {
            this.setState({ error: 'Please enter a valid 3-digit area code' });
            return;
        }

        this.setState({ allocating: true, error: null });

        // Call the allocation action
        allocatePhoneNumber(accountId, areaCode);

        // Close dialog after a short delay to allow snackbar to show
        setTimeout(() => {
            this.setState({ allocating: false });
            this.handleClose();
        }, 500);
    };

    render() {
        const { open, classes } = this.props;
        const { areaCode, allocating, error } = this.state;

        return (
            <MuiCore.Dialog
                open={open}
                onClose={(event, reason) => { if (!allocating && reason !== 'backdropClick') this.handleClose(); }}
                maxWidth="sm"
                fullWidth
                disableEscapeKeyDown={allocating}
            >
                <MuiCore.DialogTitle className={classes.dialogTitle}>
                    <MuiCore.Typography variant="h6" style={{ fontFamily: 'Sofia-bold' }}>
                        Add Phone Number
                    </MuiCore.Typography>
                    <MuiCore.IconButton
                        size="small"
                        onClick={this.handleClose}
                        disabled={allocating}
                        className={classes.closeButton}
                    >
                        <CloseIcon />
                    </MuiCore.IconButton>
                </MuiCore.DialogTitle>

                <MuiCore.DialogContent className={classes.dialogContent}>
                    <MuiCore.Typography variant="body1" style={{ marginBottom: 16, fontFamily: 'Sofia' }}>
                        Enter the area code for your new phone number. We'll allocate an available number from our inventory.
                    </MuiCore.Typography>

                    <MuiCore.TextField
                        label="Area Code"
                        variant="outlined"
                        value={areaCode}
                        onChange={this.handleAreaCodeChange}
                        className={classes.textField}
                        error={!!error}
                        helperText={error || 'Enter 3 digits (e.g., 415, 212, 310)'}
                        disabled={allocating}
                        autoFocus
                        placeholder="e.g., 415"
                        inputProps={{
                            maxLength: 3,
                            style: { fontFamily: 'Sofia', fontSize: '1.1rem' }
                        }}
                    />
                </MuiCore.DialogContent>

                <MuiCore.DialogActions className={classes.dialogActions}>
                    <MuiCore.Button
                        onClick={this.handleClose}
                        className={classes.button}
                        variant="outlined"
                        disabled={allocating}
                    >
                        Cancel
                    </MuiCore.Button>
                    <MuiCore.Button
                        onClick={this.handleAllocate}
                        className={classes.allocateButton}
                        variant="contained"
                        disabled={allocating || !areaCode || areaCode.length !== 3}
                    >
                        {allocating ? (
                            <>
                                <MuiCore.CircularProgress size={20} style={{ marginRight: 8, color: '#fff' }} />
                                Allocating...
                            </>
                        ) : (
                            'Allocate Number'
                        )}
                    </MuiCore.Button>
                </MuiCore.DialogActions>
            </MuiCore.Dialog>
        );
    }
}

const mapDispatchToProps = {
    allocatePhoneNumber: serviceActions.allocatePhoneNumber
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(PurchaseNumberDialog));
